// https://stackoverflow.com/questions/70585815/react-this-props-match-is-undefined
// https://reactrouter.com/docs/en/v6/getting-started/tutorial#reading-url-params
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import NotFoundPage from "@pages/404";
import { PrivateRoutes } from "./private.routes";
import { PublicRoutes } from "./public.routes";
const IndexRoutes = () => {
	return (
		<BrowserRouter>
			<Routes>
				{/* Public Routes */}
				{PublicRoutes.map((item, key) => {
					return (
						<Route
							key={key}
							path={item.path}
							element={<PublicAuth>{item.component}</PublicAuth>}
						/>
					);
				})}
				{/* Private Routes */}
				{PrivateRoutes.map((item, key) => {
					return (
						<Route
							key={key}
							path={item.path}
							element={<PrivateAuth>{item.component}</PrivateAuth>}
						/>
					);
				})}
				<Route path={"*"} element={<NotFoundPage />} />
			</Routes>
		</BrowserRouter>
	);
};

export default IndexRoutes;

function PrivateAuth({ children }: { children: any }) {
	return localStorage.getItem("accessToken") ? (
		children
	) : (
		<Navigate to={`/login`} />
	);
}

function PublicAuth({ children }: { children: any }) {
	return !localStorage.getItem("accessToken") ? (
		children
	) : (
		// <Navigate to={`/dashboard`} />
		<Navigate to={`/checkpoint`} />
	);
}
